import React, { useEffect } from 'react';
import SharedButton from '../../components/Shared/SharedButton';
import { useTranslation } from 'react-i18next';
import AttendanceTable from './AttendanceTable';
import { useNavigate } from 'react-router-dom';
import useFetchData from '../../hooks/useFetchData';

export default function AttendanceMain() {
  const { data: attendanceData, loading, executeFetch } = useFetchData();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    executeFetch("POST", "attendances/list", { page: 1, per_page: 10 });
  }, [executeFetch]);

  const handlePageChange = (newPage, newRowsPerPage) => {
    executeFetch("POST", "attendances/list", { page: newPage, per_page: newRowsPerPage });
  };

  const handleRefresh = () => {
    executeFetch("POST", "attendances/list", { page: 1, per_page: 10 });
  };

  return (
    <>
      <div>
        <div className='flex justify-end mb-2 '>
          <SharedButton
            label={t('CreateAttendance')}
            icon='pi pi-plus'
            onClick={() => navigate('/manager/attendance/create')}
            className='bg-primary primary-btn'
          />
        </div>
        <AttendanceTable
          data={attendanceData}
          loading={loading}
          onPageChange={handlePageChange}
          onRefresh={handleRefresh}
        />
      </div>
    </>
  );
}
